"use strict";
var transform = require('common/transform');
var confirmModalCtrl = require('./confirmModalCtrl');
var hlp = require('common/helpers');
var documentInfo = require('common/documentinfo');
var FIELD_ORDER = require('work/fieldOrder');
var controller = function($scope, $rootScope, $http, urls, id, values, schema, dianrs, Flash, permissions, $uibModal, previousId, nextId, rdfUri) {
  var testNew = function() {
    var isNew = (values === undefined || values.length === undefined || values.length == 0);
    if (!isNew) {
      var json = {};
      try {
        json = JSON.parse(values);
        isNew = (json !== undefined && (json.archivnr === undefined || json.archivnr == "" || json.archivnr.length == 0 || (json.archivnr.length > 0 && json.archivnr[0] == "")));
      } catch (ex) {
        console.log("Could not parse data as JSON", values);
        isNew = true;
      }
    }
    return isNew;
  };
  var isNew = testNew();
  var init = function() {
    $scope.urls = urls;
    $scope.id = id;
    $scope.previousId = previousId;
    $scope.nextId = nextId;
    $scope.dianrs = dianrs;
    $scope.schema = schema;
    $scope.rdfUri = rdfUri;
    $scope.loginUser = window.username;
    var schemaJson = JSON.parse(schema);
    var valuesJson = {};
    if (values !== undefined && values.length > 0) {
      try {
        valuesJson = JSON.parse(values);
      } catch (ex) {
        console.log("Could not parse data as JSON", values);
      }
    }
    if (isNew) {
      schemaJson.archivnr.readonly = false;
    } else {
      if (!_.isArray(valuesJson.archivnr)) {
        valuesJson.archivnr = [valuesJson.archivnr];
      }
    }
    $scope.fields = transform.fromSchema(schemaJson, valuesJson);
    $scope.permissions = permissions;
    if (!isNew) {
      $scope.info = JSON.parse(values)['info'];
    } else {
      $scope.info = {
        created_at: "",
        updated_at: "",
        is_public: false
      };
    }
    $scope.order = FIELD_ORDER;
    $scope.fieldsList = transform.sortFields($scope.fields, $scope.order);
    if (isNew) {
      $http.get('/api/work/newarchivnr').success(function(data, status, header, config) {
        if (data !== undefined && data.archivnr !== undefined) {
          var archivnr = data.archivnr;
          $scope.fields.archivnr.entries[0].value = archivnr;
        }
      }).catch(function(data, status, headers, config) {
        console.log('new ArchivNr exception');
        console.log('data', data);
      });
    }
    $scope.ensemblePartsPage = 1;
    $scope.ensemblePartsPerPage = 25;
    $scope.getDescriptions();
    getEnsembles();
    $scope.getEnsembleParts();
    $scope.ensembleTreeSize = 0;
    $scope.ensembleTree = [];
    $scope.thumbnailUrl = undefined;
    $scope.popup = undefined;
    if (!isNew) {
      $scope.thumbnailUrl = popup.thumbnailUrl;
      $scope.popup = popup.open;
      $scope.getEnsembleTree();
    }
  };
  $scope.$watch('title', function() {
    if (hlp.isSet($scope.id) && hlp.isSet($scope.title)) {
      window.document.title = $scope.id + " - " + $scope.title + " - Werk";
    }
  }, true);
  $scope.setPage = function(page) {
    $scope.ensemblePartsPage = page;
    $scope.getEnsembleParts();
  };
  var getEnsembles = function() {
    if (!$scope.fields.ensemblenr || $scope.fields.ensemblenr.entries.length == 0 || ($scope.fields.ensemblenr.entries.length == 1 && $scope.fields.ensemblenr.entries[0].value.length == 0)) {
      return;
    }
    var params = {"archivnr": $scope.fields.ensemblenr.entries[0].value};
    $http.get('/api/work.json', {params: params}).success(function(data, status, headers, config) {
      $scope.ensembles = data.works;
    }).catch(function(data, status, headers, config) {
      console.log('Get Ensembles exception');
      console.log('data', data);
    });
  };
  $scope.getEnsembleParts = function() {
    var params = {
      "ensemblenr": $scope.id,
      "page": $scope.ensemblePartsPage,
      "per_page": $scope.ensemblePartsPerPage
    };
    $http.get('/api/ensemble.json', {params: params}).success(function(data, status, headers, config) {
      $scope.ensembleParts = data.works;
      $scope.ensemblePartsTotalCount = data.count;
    }).catch(function(data, status, headers, config) {
      console.log('Get Ensemble Parts exception');
      console.log('data', data);
    });
  };
  $scope.getEnsembleTree = function() {
    var params = {"archivnr": $scope.id};
    $http.get('/api/ensemble/tree', {params: params}).success(function(data, status, headers, config) {
      createEnsembleTree(data.works);
    }).catch(function(data, status, headers, config) {
      console.log('Get Ensemble Tree exception');
      console.log('data', data);
    });
  };
  var createEnsembleTree = function(tree) {
    $scope.ensembleTreeSize = 0;
    $scope.ensembleTree = [];
    var treeDict = {};
    var sortedEntries = [];
    var withSubElements = [];
    tree.forEach(function(item) {
      var depth = item.depth;
      if (depth == "0") {
        treeDict[item.archivnr] = {
          'archivnr': item.archivnr[0],
          'bildthema': item.bildthema[0],
          'ensemblebezeichnung': null,
          'depth': depth,
          'ensemblenr': item.ensemblenr[0],
          'metadata': item.metadata,
          'dianr': item.dianr,
          'hasSubElements': false
        };
        if (item.ensemblebezeichnung !== undefined && item.ensemblebezeichnung.length > 0) {
          treeDict[item.archivnr].ensemblebezeichnung = item.ensemblebezeichnung[0];
        }
        sortedEntries.push(item.archivnr);
        $scope.ensembleTreeSize++;
      } else {
        withSubElements.push(item.ensemblenr[0]);
      }
    });
    withSubElements.forEach(function(archivnr) {
      if (archivnr in treeDict) {
        treeDict[archivnr].hasSubElements = true;
      }
    });
    sortedEntries.sort();
    sortedEntries.forEach(function(item) {
      $scope.ensembleTree.push(treeDict[item]);
    });
  };
  var setEnsemble = function(oldFields, newFields, onlyBlank) {
    for (var key in oldFields) {
      if (key == 'archivnr' || key == 'ensemblenr') {
        continue;
      }
      if (typeof newFields[key] != 'undefined') {
        if (onlyBlank == true && oldFields[key].entries.length > 1 && oldFields[key].entries[0].value.length != 0) {
          continue;
        }
        oldFields[key] = newFields[key];
      }
    }
    ;
  };
  $rootScope.setAllByEnsemble = function(entry) {
    if (entry.value.length == 0 || entry.notFound == true) {
      return;
    }
    $http.get('/api/work/' + entry.value + '.json').then(function(response) {
      var fields = transform.fromSchema(JSON.parse(schema), response.data);
      setEnsemble($scope.fields, fields);
      $scope.fieldsList = transform.sortStrings($scope.fields, $scope.order);
    });
  };
  $rootScope.setEmptyByEnsemble = function(entry) {
    if (entry.value.length == 0 || entry.notFound == true) {
      return;
    }
    $http.get('/api/work/' + entry.value + '.json').then(function(response) {
      var fields = transform.fromSchema(JSON.parse(schema), response.data);
      setEnsemble($scope.fields, fields, true);
      $scope.fieldsList = transform.sortStrings($scope.fields, $scope.order);
    });
  };
  $scope.save = function() {
    if (id != null) {
      $scope.update(id);
    } else {
      $scope.create();
    }
  };
  $scope.update = function(id) {
    var fields = transform.toSchema($scope.fields);
    if (_.isArray(fields.values['archivnr'])) {
      fields.values['archivnr'] = fields.values['archivnr'][0];
    }
    fields.values['info'] = $scope.info;
    $http.post('/api/work/' + id + '.json', angular.toJson(fields.values)).then(function(response) {
      var message = '<strong>Erfolgreich gespeichert!</strong>.';
      window.location = '/work/' + response.data.archivnr;
    }, function(response) {
      var message = '<strong>Fehler beim speichern!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  $scope.create = function() {
    var fields = transform.toSchema($scope.fields);
    if ($scope.fields.archivnr.entries.length > 0 && $scope.fields.archivnr.entries[0].value.length > 0) {
      fields.values['archivnr'] = $scope.fields.archivnr.entries[0].value;
    }
    fields.values['info'] = $scope.info;
    $http.post('/api/work.json', angular.toJson(fields.values)).then(function(response) {
      window.location = '/work/' + response.data.archivnr;
    }, function(response) {
      var message = '<strong>Fehler beim speichern!</strong>';
      if (response !== undefined && response.data !== undefined && response.data.message !== undefined) {
        message += ' - <strong>' + response.data.message + '</strong>';
      }
      Flash.create('danger', message, 0, {}, true);
    });
  };
  $scope.getDescriptions = function() {
    var archivnr = $scope.id;
    if (archivnr == null) {
      return;
    }
    $scope.loading = true;
    var params = {
      "archivnr": archivnr,
      "query": '',
      "page": 1,
      "per_page": 100
    };
    $http.get('/api/description.json', {params: params}).success(function(data, status, headers, config) {
      $scope.descriptions = data.descriptions;
    }).catch(function(data, status, headers, config) {
      console.log("Error getting description. Status: " + status);
      console.log("Params: ", params);
      console.log("data: ", data);
    }).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.$watch('fields.bildthema.entries', function() {
    if ($scope.fields.bildthema.entries.length > 0 && $scope.fields.bildthema.entries[0].value.length > 0) {
      $scope.title = $scope.fields.bildthema.entries[0].value;
    } else {
      $scope.title = '<Bildthema>';
    }
  }, true);
  $scope.popupOpen = function(dianr) {
    popup.open($scope.id, dianr);
    return true;
  };
  $scope.hasPermission = function(permission) {
    if (typeof $scope.permissions == 'undefined' || $scope.permissions == null) {
      return false;
    }
    var index = $scope.permissions.indexOf(permission);
    if (index > -1) {
      return true;
    }
    return false;
  };
  $scope.canEdit = function(info) {
    if (typeof info == 'undefined' || info == null) {
      return false;
    }
    return (info.state == 'confirmed' || info.user == window.username);
  };
  $scope.getDate = function(timestamp) {
    if (typeof timestamp == 'undefined' || timestamp == null) {
      return "";
    }
    moment.locale("de-at");
    return moment(timestamp.$date, "x").format("D.M.YY HH:mm");
  };
  $scope.cancel = function() {
    if (typeof $scope.info == 'undefined' || $scope.info == null || $scope.info.state !== 'editing_started') {
      window.location = '/work/' + $scope.id;
    } else {
      window.location = '/work/cancelEdit/' + $scope.id;
    }
  };
  $scope.stateInfo = documentInfo.stateInfo;
  $scope.canRevert = documentInfo.canRevert;
  $scope.canConfirm = documentInfo.canConfirm;
  $scope.openConfirmModal = function(modal) {
    var modalInstance = $uibModal.open({
      templateUrl: 'work/templates/' + modal + '.ng.html',
      controller: confirmModalCtrl,
      resolve: {deleteParams: function() {
          if (!hlp.isSet($scope.descriptions)) {
            $scope.descriptions = [];
          }
          return {
            id: $scope.id,
            descriptions: $scope.descriptions
          };
        }}
    });
  };
  var findField = function(fields, name) {
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].schema.name == name) {
        return i;
      }
    }
    return -1;
  };
  init();
};
module.exports = controller;
